/**
 * Enum to define the origin of the resource.
 *
 * The `ResourceOriginEnum` is used to evaluate the source for the bridge,
 * which helps determine which endpoint to call during the Preview & Execution phase.
 * * - 'novu-cloud' indicates that the resource originates from Novu's platform, so the Novu-hosted endpoint is used.
 * * - 'external' indicates that the resource originates from an external source, requiring a call to a customer-hosted Bridge endpoint.
 */
export var ResourceOriginEnum;
(function (ResourceOriginEnum) {
    ResourceOriginEnum["NOVU_CLOUD"] = "novu-cloud";
    ResourceOriginEnum["NOVU_CLOUD_V1"] = "novu-cloud-v1";
    ResourceOriginEnum["EXTERNAL"] = "external";
})(ResourceOriginEnum || (ResourceOriginEnum = {}));
/**
 * Enum to define the type of the resource.
 *
 * One of its responsibilities is to help the API determine whether "changes" need to be created during the upsert process.
 */
export var ResourceTypeEnum;
(function (ResourceTypeEnum) {
    ResourceTypeEnum["REGULAR"] = "REGULAR";
    /** @deprecated Use BRIDGE instead */
    ResourceTypeEnum["ECHO"] = "ECHO";
    ResourceTypeEnum["BRIDGE"] = "BRIDGE";
})(ResourceTypeEnum || (ResourceTypeEnum = {}));
//# sourceMappingURL=general.js.map